<template>
  <div id="grid-pagos">
    <v-container grid-list-xl fluid>
      <v-layout>
        <v-flex lg12>
          <!-- Select de contratos agregado -->
          <v-layout justify-start class="mb-4" align-center>
            <v-flex xs12 md4>
              <v-select 
                v-model="idContratoValue" 
                :items="idContratoSelect" 
                label="Periodo / Contrato"
                item-text="nombre" 
                item-value="code"
              ></v-select>
            </v-flex>
            <v-flex xs12 md1 >
              <v-btn 
                color="primary" 
                @click="loadDataConsulta()"
                :disabled="!idContratoValue"
              >
                <v-icon left>search</v-icon>
                Filtrar
              </v-btn>
            </v-flex>
            <!-- Botón para limpiar el select y buscar sin valores -->
            <v-flex xs12 md2 class="ml-2">
              <v-btn 
                color="warning" 
                @click="clearSelect()"
              >
                <v-icon left>clear</v-icon>
                Limpiar
              </v-btn>
            </v-flex>
          </v-layout>
          <div v-if="loading">
            <loading></loading>
          </div>
          <v-spacer></v-spacer>
          <template>
            <v-data-table
              :items="itemsMultas"
              :headers="headers"
              :rows-per-page-items="rowsPerPageItems"
              class="elevation-1"
            >
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.periodo }}</td>
                <td class="text-xs-left">{{ props.item.idContrato }}</td>
                <td class="text-xs-left">{{ props.item.fechaMulta }}</td>
                <td class="text-xs-left">{{ props.item.monto }}</td>
                <td class="text-xs-left">{{ props.item.productoReporte }}</td>
                <td class="text-xs-left">{{ props.item.proveedor }}</td>
                <td class="text-xs-left">{{ props.item.observacion }}</td>
                <td class="text-xs-left">
                  <v-btn
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="primary"
                    title="Descargar registro"
                    small
                    @click="downloadFile(props.item.id, props.item.idContrato)"
                  >
                    <v-icon>cloud_download</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="
                      props.item.filename != null &&
                      props.item.filename != '' &&
                      props.item.filename !== undefined
                    "
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="success"
                    title="Descargar documento"
                    small
                    @click="
                      downloadFile2(props.item.id, props.item.filename, props.item.idContrato)
                    "
                  >
                    <v-icon>cloud_download</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
            <!-- LEYENDA TABLA PROVEEDORES -->
            <v-card-actions class="pb-3">
              <v-spacer></v-spacer>
              <div class="text-xs-center">
                <td>
                  <template>
                    <v-btn
                      class="btn-sigas"
                      depressed
                      outline
                      title="Descargar documento"
                      icon
                      fab
                      dark
                      color="primary"
                      small
                    >
                      <v-icon>cloud_download</v-icon> </v-btn
                    >Descargar registro
                    <v-btn
                      class="btn-sigas"
                      depressed
                      outline
                      title="Descargar documento"
                      icon
                      fab
                      dark
                      color="success"
                      small
                    >
                      <v-icon>cloud_download</v-icon> </v-btn
                    >Descargar documento
                  </template>
                </td>
              </div>
            </v-card-actions>
          </template>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import AlertPago from "@/views/ui/AlertPago.vue";

export default {
  name: "grid-detalle-multa",

  components: {
    Loading,
    AlertPago,
  },
  props: {
    rowsTable: "",
    tipeView: "",
    idContrato: "",
    select: "",
  },

  data() {
    return {
      // idContrato: "",
      loading: false,
      id: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      headers: [
        { text: "Periodo", align: "left", sortable: false, value: "periodo" },
        { text: "Fecha", sortable: false, value: "fecha" },
        { text: "Monto", sortable: false, value: "monto" },
        { text: "Numeral", sortable: false, value: "numeral" },
        { text: "Proveedor", sortable: false, value: "proveedor" },
        { text: "Observación", sortable: false, value: "observacion" },
        { text: "Acciones", sortable: false, value: "acciones" },
      ],
      usuarioLoggedTipe: "",
      itemsMultas: [],
      multasEstados: [],
      result: [],
      idUserLogged: "",
      proceso: "",
      pagoValue: "",
      idContratoValue: "",
        idContratoSelect: [],
    };
  },

  created() {
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idUserLogged = this.$store.getters.userLogged.id;
    this.proceso = this.$store.getters.proSelectedStored;
    this.loadContratosByIdUsuario(); 
    this.loadDataConsulta();
  },
  mounted() {},
  computed: {},
  methods: {
    // Método para limpiar el select y buscar sin filtro
    clearSelect() {
      this.idContratoValue = "";
      this.loadDataConsulta();
    },
    async loadContratosByIdUsuario() {
  try {
    const body = { userId: this.idUserLogged };
    const response = await axios.post("/contratos/usuarios/filter", body);
    this.idContratoSelect = response.data.map(p => ({
      nombre: p.periodo + " / "+ p.codigo,
      code: p.id
    }));
  } catch (error) {
    console.error("Error al cargar contratos:", error);
  }
},
    async loadMultasFilter() {
      this.body = {
        idContrato: this.idContratoValue || "", // Filtro agregado
        id: null,
        perido: null,
        productoReporte: null,
        estado: null,
      };
      return await axios
        .post("/pagosMultas/multas", this.body)
        .then(function (response) {
          console.log("MULTAS::::" + JSON.stringify(response.data, null, 2));
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            /*  window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message); */
          }
          return [];
        });
    },

    //POST ,  BODY IDCONTRATO,FILENAME
    async downloadFile(id, idContratoIn) {
      let filenameOut = "Descarga_Registro_Multas_" + id + ".xlsx";
      return await axios
        .get("/pagosMultas/downloadExcel/" + id + "/" + idContratoIn, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filenameOut);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    //POST ,  BODY IDCONTRATO,FILENAME
    async downloadFile2(idIn, filename, idcontratoIn) {
      this.body = {
        fileName: "/multas/"+ filename,
        id: idIn,
        idContrato: idcontratoIn
      };

      axios
        .post("pagosMultas/downloadAdjunto/", this.body, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    async loadDataConsulta() {
      if (this.idContrato > 0) {
        console.log("es mayor");
      }
      this.loading = true;

      this.itemsMultas = await this.loadMultasFilter();

      if (this.itemsMultas.length > 0) {
        this.alerta = false;
      } else {
        this.alerta = true;
      }
      this.loading = false;
    },
  },
};
</script>
